import { Route, BrowserRouter, Routes } from "react-router-dom";
import { HomePage } from "./pages/home/home";
import { BlogPage } from "./pages/home/blog/bloghome";
import { BlogPost } from "./pages/home/blog/blogPost";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </BrowserRouter>
  );
}
